module.exports = __webpack_public_path__ + "static/media/dicero_page_area02_img_en.b784622f.png";